import { useTranslations } from "adapters/i18n";
import { useMemo } from "react";
import type { Retreat } from "shared/types";
import {
  MeasuredWeightFilter,
  ProjectedWeightFilter,
  RETREAT_FILTER_ALL_VALUE,
} from "../utils/lots.utils";

type UseFilterFormOptionsProps = {
  farmRetreats: Retreat[];
};

export function useFilterFormOptions({
  farmRetreats,
}: UseFilterFormOptionsProps) {
  const { t } = useTranslations();

  const retreatOptions = useMemo(() => {
    const options = farmRetreats
      .map((retreat) => ({
        label: retreat.name,
        value: retreat.id,
      }))
      .sort((a, b) => a.label.localeCompare(b.label));

    options.unshift({
      label: t("common:all-male"),
      value: RETREAT_FILTER_ALL_VALUE,
    });
    return options;
  }, [t, farmRetreats]);

  const measuredWeightOptions = useMemo(
    () => [
      { value: MeasuredWeightFilter.All, label: t("common:all-male") },
      {
        value: MeasuredWeightFilter.Informed,
        label: t("common:informed"),
      },
      {
        value: MeasuredWeightFilter.NotInformed,
        label: t("common:not-informed"),
      },
    ],
    [t]
  );

  const projectedWeightOptions = useMemo(
    () => [
      { value: ProjectedWeightFilter.All, label: t("common:all-male") },
      {
        value: ProjectedWeightFilter.Available,
        label: t("common:available"),
      },
      {
        value: ProjectedWeightFilter.NotAvailable,
        label: t("common:not-informed"),
      },
    ],
    [t]
  );

  return {
    retreatOptions,
    measuredWeightOptions,
    projectedWeightOptions,
  };
}
